import { useSelector } from 'react-redux';

const usePlayerOverlay = (onClick, isEnabled) => {
  const newState = useSelector( state => state.inRoomPM && !isEnabled );
  const newOnclick = () => { window['pm-warning'](null, 'Automix is disabled in B2B Mode.'); }
  return newState ? newOnclick : onClick;
};

export default usePlayerOverlay;
